import { render, staticRenderFns } from "./OrderInfoModal.vue?vue&type=template&id=4b3276c7&"
import script from "./OrderInfoModal.vue?vue&type=script&lang=ts&"
export * from "./OrderInfoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b3276c7')) {
      api.createRecord('4b3276c7', component.options)
    } else {
      api.reload('4b3276c7', component.options)
    }
    module.hot.accept("./OrderInfoModal.vue?vue&type=template&id=4b3276c7&", function () {
      api.rerender('4b3276c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/machinetranslations/OrderInfoModal.vue"
export default component.exports